import {
  Button,
  Col,
  DatePicker,
  Divider,
  Empty,
  Flex,
  Form,
  Input,
  message,
  notification,
  Row,
  Select,
  Table,
  Typography
} from 'antd';
import axios from 'axios';
import {apiBasePath} from '../../utils/constants';
import {useContext, useEffect, useMemo, useState} from 'react';
import dayjs from 'dayjs';
import {Loading} from '../common';
import {SearchOutlined} from '@ant-design/icons';
import {GlobalContext} from '../../utils/globalContext';
import locale from 'antd/es/date-picker/locale/es_ES';
import {setDataTableSource} from './normalize';
import {ActionColumnFact} from '../common/tableCustomColumns';
import {useNavigate} from 'react-router-dom';
import {withTrimmedForm} from '../../utils/utils';

export const InvoiceStorage = () => {
  const [form] = Form.useForm();
  const [parkingList, setParkingList] = useState([]);
  const [cfdiUse, setCFDIuse] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false);
  const [loadingInvoice, setLoadingInvoice] = useState(false);
  const [emails, setEmails] = useState([]);
  const [amountsAdded, setAmountsAdded] = useState(null);
  const [paymentMethodList, setPaymentMethodList] = useState([]);
  const [remoteConfig, setRemoteConfig] = useState({
    availablePaymentInfo: false,
    availablePension: false
  });
  const navigate = useNavigate();
  const [notificationApi, contextHolderNotification] = notification.useNotification();
  const [messageApi, contextHolder] = message.useMessage();
  const {user} = useContext(GlobalContext);
  const onFinish = async (values) => {
    setLoadingSave(true);
    try {
      const fecha = dayjs(values.date).startOf('month').format('YYYY-MM-DD');
      const responseInsertInvoice = await axios.get(
        `${apiBasePath}/invoice/available-income-pension/clie_id/${user.clie_id}/parkingCode/${values.parking}/operationDate/${fecha}/external-id/${values.externalId}`
      );
      const source = setDataTableSource(responseInsertInvoice.data.lstInvoicePensionExternal, parkingList);
      setAmountsAdded(source);
    } catch (error) {
      console.error('🚀 ~ onFinish ~ error:', error);
    } finally {
      setLoadingSave(false);
    }
  };
  const handleInvoice = async (record) => {
    setLoadingInvoice(true);
    const inputsValues = form.getFieldsValue();
    try {
      await axios.post(`${apiBasePath}/invoice`, {
        cates_descr_corta_str: parkingList.find(
          (parking) => String(parking.cates_id_int) === String(inputsValues.parking)
        ).cates_descr_corta_str,
        cates_id_int: inputsValues.parking,
        clie_id: user.clie_id,
        invoiceCaptureDetail: [{amount: record.amount, code: record.key}],
        invoiceEmail: emails?.map((email) => ({email})),
        invoice_type: 2,
        oper_fecha: dayjs(inputsValues.date).format('YYYY-MM-DD'),
        oper_uso_cfdi: cfdiUse.find((cfdi) => cfdi.id === inputsValues.cfdi).code,
        oper_uso_cfdi_desc: cfdiUse.find((cfdi) => cfdi.id === inputsValues.cfdi).description,
        forma_pago: inputsValues.paymentType,
        metodo_pago: inputsValues.paymentMethod,
      });
      messageApi.open({
        type: 'info',
        content: 'Su documento se encuentra en proceso de facturación, favor de validar en el Menú de Mis Facturas'
      });
      notificationApi.open({
        type: 'info',
        message: 'Facturación en proceso',
        description: 'Su documento se encuentra en proceso de facturación, favor de validar en el Menú de Mis Facturas',
        btn: (
          <Button type="primary" size="small" onClick={() => navigate('/invoice-list')}>
            Ir a Mis Facturas
          </Button>
        ),
        showProgress: true,
        pauseOnHover: true
      });
    } catch (error) {
      messageApi.open({
        type: 'error',
        content: 'Error al intentar generar la facturar, por favor contacte al administrador'
      });
    } finally {
      setLoadingInvoice(false);
    }
  };

  const getInitData = async () => {
    setLoading(true);
    try {
      const responseParkingList = await axios.get(`${apiBasePath}/reference-data/parking`);
      const responseCFDIList = await axios.get(`${apiBasePath}/reference-data/cfdi-use`);
      const responsePaymentMethodList = await axios.get(`${apiBasePath}/reference-data/way-payment`);

      const respConfigAvailablePaymentInfo = await axios.get(
        `${apiBasePath}/reference-data/conf-general/AVAILABLE_PAYMENT_INFO`
      );
      const respConfigAvailablePension = await axios.get(
        `${apiBasePath}/reference-data/conf-general/AVAILABLE_PENSION`
      );
      setRemoteConfig({
        ...remoteConfig,
        availablePaymentInfo: respConfigAvailablePaymentInfo.data.generalConfig.conf_value === '1',
        availablePension: respConfigAvailablePension.data.generalConfig.conf_value === '1'
      });
      setPaymentMethodList(responsePaymentMethodList.data.wayPayment.data);

      setCFDIuse(responseCFDIList.data?.cfdiUse?.data);
      setParkingList(responseParkingList.data.lstParking);
      setEmails([user.clie_correo]);
    } catch (error) {
      console.error('🚀 ~ getParkingList ~ error:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getInitData();
  }, []);

  const columnsTable = useMemo(() => {
    return [...(amountsAdded?.columns ?? []), ActionColumnFact(handleInvoice, loadingInvoice)];
  }, [amountsAdded?.columns]);
  return (
    <div className="basic-layout">
      {contextHolder}
      {contextHolderNotification}
      <Row align={'middle'}>
        <Col>
          <h1>Facturación de Pensiones</h1>
        </Col>
      </Row>
      <Row>
        <Form
          name="invoicePensionForm"
          form={form}
          layout="vertical"
          autoComplete="off"
          onFinish={withTrimmedForm(onFinish)}
          style={{width: '100%', justifyContent: 'flex-end', alignItems: 'center'}}>
          <Row gutter={16}>
            <Col md={4} sm={24}>
              <Form.Item
                name="parking"
                label="Estacionamiento"
                rules={[{required: true, message: 'Por favor, ingresa el estacionamiento'}]}>
                <Select
                  loading={loading}
                  allowClear
                  showSearch
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}>
                  {parkingList.map((parking) => (
                    <Select.Option
                      key={parking.cates_id_int}
                      value={parking.cates_id_int}
                      label={`${parking.cates_id_int} - ${parking.cates_descripcion_str}`}>
                      {`${parking.cates_id_int} - ${parking.cates_descripcion_str}`}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col md={3} xs={24}>
              <Form.Item
                name="date"
                label="Fecha"
                rules={[{required: true, message: 'Por favor, ingresa la fecha'}]}>
                <DatePicker locale={locale} picker="month" format={'MM-YYYY'} style={{width: '100%'}} />
              </Form.Item>
            </Col>
            <Col md={3} xs={24}>
              <Form.Item
                name="externalId"
                label="Id Externo"
                rules={[{required: true, message: 'Por favor, ingresa id externo'}]}>
                <Input />
              </Form.Item>
            </Col>
            <Col md={4} xs={24}>
              <Form.Item
                name="paymentType"
                label="Forma de Pago"
                initialValue={'01'}
                rules={[{required: true, message: 'Por favor, ingresa la forma de pago'}]}>
                <Select
                  defaultValue={'01'}
                  showSearch
                  disabled={!user.isAdmin && !remoteConfig.availablePaymentInfo}
                  filterOption={(input, option) => option?.label.toLowerCase().includes(input.toLowerCase())}
                  options={[
                    {value: '', label: 'Seleccione forma de pago'},
                    ...paymentMethodList.map((paymentMethod) => ({
                      value: paymentMethod.code,
                      label: `${paymentMethod.code} - ${paymentMethod.description}`
                    }))
                  ]}
                />
              </Form.Item>
            </Col>
            <Col md={4} xs={24}>
              <Form.Item
                name="paymentMethod"
                label="Método de Pago"
                initialValue={'PUE'}
                rules={[{required: true, message: 'Por favor, ingresa el método de pago'}]}>
                <Select
                  defaultValue={'PUE'}
                  disabled={!user.isAdmin && !remoteConfig.availablePaymentInfo}
                  options={[
                    {value: '', label: 'Seleccione método de pago'},
                    {value: 'PPD', label: 'PPD - Pago en parcialidades o diferido'},
                    {value: 'PUE', label: 'PUE - Pago en una exhibición'}
                  ]}
                />
              </Form.Item>
            </Col>
            <Col md={4} sm={24}>
              <Form.Item
                name="cfdi"
                label="Uso de CFDI"
                rules={[{required: true, message: 'Por favor, ingresa el uso de CFDI'}]}>
                <Select
                  loading={loading}
                  allowClear
                  showSearch
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}>
                  {cfdiUse.map((cfdi) => (
                    <Select.Option key={cfdi.id} value={cfdi.id} label={`${cfdi.code} - ${cfdi.description}`}>
                      {`${cfdi.code} - ${cfdi.description}`}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col md={2} sm={24} style={{display: 'flex', alignItems: 'center'}}>
              <Button type="primary" icon={<SearchOutlined />} htmlType="submit" size="large" loading={loadingSave}>
                Buscar
              </Button>
            </Col>
          </Row>
        </Form>
      </Row>

      <Divider />
      <Row gutter={32} justify="center">
        <Col span={24}>
          {loadingSave ? (
            <Loading />
          ) : (
            <>
              {amountsAdded ? (
                <Table dataSource={amountsAdded.dataSource} columns={columnsTable} bordered pagination={false} />
              ) : (
                <Flex justify="center" align="center" style={{height: '100%'}}>
                  <Empty description={<Typography.Text>Busca tus pagos para facturar</Typography.Text>} />
                </Flex>
              )}
            </>
          )}
        </Col>
      </Row>
    </div>
  );
};
